export default __webpack_public_path__ + "static/media/copyToClipboardBlue.c375df10.svg";